import { render, staticRenderFns } from "./contractReview.vue?vue&type=template&id=b530ed0c&scoped=true&"
import script from "./contractReview.vue?vue&type=script&lang=js&"
export * from "./contractReview.vue?vue&type=script&lang=js&"
import style0 from "./contractReview.vue?vue&type=style&index=0&id=b530ed0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b530ed0c",
  null
  
)

export default component.exports